import { OrderStatus } from '@truepill/tpos-types'
import type { Task } from 'providers/TaskProvider'
import type { ScannedTask } from 'types'

/**
 * Builds the scannedTasks array for printShippingLabel mutation.
 * Only includes OTC/PM tasks with scanned UPCs when order is in Packing status.
 */
export const getScannedTasksForShippingLabel = (orderStatus: string, tasks: Task[]): ScannedTask[] => {
  if (orderStatus !== OrderStatus.Packing) return []

  return tasks
    .filter(task => (task.productType === 'OTC' || task.productType === 'PM') && task.additionalData?.upcScanned)
    .map(task => ({
      sku: task.code,
      upc: task.additionalData?.upcScanned,
      productType: task.productType,
    }))
}
